'use client';

import { TagSimpleIcon } from '@phosphor-icons/react';
import { CategoryIcon } from './CategoryIcon';
import { getCategoryChipStyle, normalizeCategoryKey, type CategoryColorIntent } from '@/lib/category';

export interface CategoryChipProps {
  categoryKey: string;
  label: string;
  iconName?: string | null;
  size?: 'sm' | 'md';
  iconOnly?: boolean;
  className?: string;
  title?: string;
  intent?: CategoryColorIntent;
}

export function CategoryChip({
  categoryKey,
  label,
  iconName,
  size = 'sm',
  iconOnly = false,
  className = '',
  title,
  intent = 'neutral',
}: CategoryChipProps) {
  const style = getCategoryChipStyle(normalizeCategoryKey(categoryKey), intent);
  const isMd = size === 'md';
  const iconBoxCls = isMd ? 'size-7' : 'size-6';
  const iconCls = isMd ? 'h-3.5 w-3.5' : 'h-3 w-3';
  const textCls = isMd ? 'text-2xs' : 'text-2xs';

  if (iconOnly) {
    return (
      <span
        className={`inline-flex shrink-0 items-center justify-center rounded-full ${iconBoxCls} ${className}`}
        style={{ backgroundColor: style.backgroundColor }}
        title={title ?? label}
        aria-label={`Categoria: ${label}`}
      >
        <CategoryIcon
          name={iconName ?? undefined}
          className={iconCls}
          style={{ color: style.color }}
          fallback={<TagSimpleIcon className={iconCls} weight="duotone" style={{ color: style.color }} />}
        />
      </span>
    );
  }

  const heightCls = isMd ? 'h-7' : 'h-6';
  const innerIconBoxCls = isMd ? 'size-6' : 'size-5';
  return (
    <span
      className={`inline-flex max-w-full items-center gap-1 rounded-full pl-0.5 pr-2 ${heightCls} ${className}`}
      style={{ backgroundColor: style.backgroundColor }}
      title={title ?? label}
      aria-label={`Categoria: ${label}`}
    >
      <span className={`flex shrink-0 items-center justify-center rounded-full ${innerIconBoxCls}`}>
        <CategoryIcon
          name={iconName ?? undefined}
          className={iconCls}
          style={{ color: style.color }}
          fallback={<TagSimpleIcon className={iconCls} weight="duotone" style={{ color: style.color }} />}
        />
      </span>
      <span className={`min-w-0 truncate font-bold ${textCls}`} style={{ color: style.color }}>
        {label}
      </span>
    </span>
  );
}
